import type { MouseEventHandler } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { useFilterContext } from "./FilterContext";

interface AddonFilterChipProps {
  hasValue: boolean;
  shouldShowClearButton?: boolean;
}

export const AddonFilterChip = ({
  hasValue,
  shouldShowClearButton = true,
}: AddonFilterChipProps) => {
  const { onApply } = useFilterContext();

  if (!hasValue) {
    return (
      <Icon type="16-add-sm" size={16} aria-hidden useWithFillCurrentColor />
    );
  }
  if (!shouldShowClearButton) {
    // Maintain spacing on the Filterbar
    return <div aria-hidden />;
  }

  const handleClear: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    onApply(null);
  };

  return (
    <button
      type="button"
      className="focus-visible:ring-secondary focus-visible:ring-1"
      aria-label={t("filters.clear")}
      onClick={handleClear}
    >
      <Icon type="16-close" size={16} useWithStrokeCurrentColor />
    </button>
  );
};
